import React from 'react';
import {Metric} from '../../models/Metric';
import {MetricView} from './MetricView';

type TracksList = {
    metrics: Metric[]
}

export const MetricsList = ({metrics}: TracksList) => {
    return (
        <div>
            {metrics.map((metric, index) => {
                return <MetricView
                  key={metric.id}
                  metric={metric}
                  arrayIndex={index}
                />
            })}
        </div>
    );
};
